import React, { useState } from "react";

function ProjectSearch({ onSearch, onCreate }) {
    const [name, setName] = useState('');

    const handleSearch = (e) => {
        e.preventDefault();
        onSearch(name);
    };

    return (
        <div className="search-container">
            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    placeholder="Search by project name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <button type="submit">Search</button>
            </form>
            <button onClick={onCreate}>Create New Project</button>
        </div>
    );
}

export default ProjectSearch;
